import { Container, Stack } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import { Header } from './Header';

export const DashboardLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack minHeight="100vh">
      <Header />
      <Container maxWidth="xl">{children}</Container>
    </Stack>
  );
};
